import * as React from 'react';
export var ChevronLeft = function ChevronLeft(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 29 48"
  }, React.createElement("path", {
    d: "M0.1,24l24-24l4.8,4.8L9.7,24l19.2,19.2L24.1,48L0.1,24z"
  }));
};